// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"572b545f","453":"a6a19004","777":"161b28e0"}[chunkId] + ".chunk.js";
};